<template>
  <div>
    <div v-if="msg" class="linkedin-post-preview-body__message" v-html="msg"></div>
    <shared-social-post-preview-image :title="heading" :image="image" max-width="80%" padding="37px" />
    <div class="linkedin-post-preview-body__content">
      <div v-if="heading" class="linkedin-post-preview-body__title" v-html="heading"></div>            
    </div>
  </div>
</template>

<script>
import {extractSocialPostStepPieces} from '../../mixins/extractSocialPostStepPieces.mixin';
import SharedSocialPostPreviewImage from '../shared/SharedSocialPostPreviewImage';

export default {
  mixins: [extractSocialPostStepPieces],
  components: {SharedSocialPostPreviewImage},
  props: {
    pieces: Array,
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../../../../sass/web/_variables';

.linkedin-post-preview-body {
  &__message,
  &__content {
    font-size: 14px;
  }
  &__message {
    padding: 0 15px 5px;
    color: $black-color;
  }
  &__content {
    padding: 10px 15px;
    background: #eef3f7;
  }
  &__title {
    font-weight: bold;    
    word-break: break-word;
  }
}
</style>
